import { List, Map, OrderedMap } from 'immutable'
import Cookies from 'js-cookie'

import {
  LOGIN,
  FETCH_CURRENT_USER,
  DESELECT,
  SELECT,
  DESELECT_ALL,
  EDIT_USER,
  ZOOM,
  FETCH_USER_STATS,
  CREATE_VIDEO,
  DELETE_VIDEO
} from '../actions'

const initialState = {
  loggingIn: false,
  selected: new List(),
  groups: new List(),
  tags: new List(),
  uploads: 0,
  isFetching: true,
  userExists: null,
  stats: {
    hot: null,
    plays: null,
    referrers: null,
    vtrs: null,
  },
  videosView: 'grid',
  sub_accounts: new List(),
  ads: new List(),
  embed_options: new Map(),
  ua: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  user_name: Cookies.get("user_name"),
  dark_mode: Cookies.get("dark_mode") == 'true',
  twitter: '',
}

export default function me(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      if (action.error) {
        return {
          ...state,
          loggingIn: false,
          error: true,
          message: action.payload.message,
        }
      }
      return {
        ...state,
        ...action.payload,
      }
    case FETCH_CURRENT_USER:
      if (action.error) {
        return {
          ...state,
          user_name: null,
        }
      }
      return {
        ...state,
        ...action.payload,
        isFetching: false,
        groups: action.payload.groups ? new List(action.payload.groups) : new List(),
        tags: action.payload.tags ? new List(action.payload.tags) : new List(),
        sub_accounts: action.payload.sub_accounts
          ? new List(action.payload.sub_accounts)
          : new List(),
      }
    case DESELECT:
      return {
        ...state,
        selected: state.selected.delete(state.selected.indexOf(action.payload)),
      }
    case SELECT:
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          selected: new List(action.payload),
        }
      }
      return {
        ...state,
        selected: state.selected.push(action.payload),
      }
    case DESELECT_ALL:
      return {
        ...state,
        selected: new List(),
      }
    case EDIT_USER:
      return {
        ...state,
        ...action.payload,
        ads: action.payload.ads ? new List(action.payload.ads) : state.ads,
      }
    case ZOOM:
      return {
        ...state,
        zoomed: action.payload,
      }
    case CREATE_VIDEO:
      return {
        ...state,
        uploads: state.uploads + 1,
      }
    case FETCH_USER_STATS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.payload,
          lastNow: state.stats.now,
          now: action.payload.live ? action.payload.live.count : 0,
        },
      }
    case DELETE_VIDEO:
      return {
        ...state,
        selected: state.selected.delete(state.selected.indexOf(action.payload.shortcode)),
      }
    default:
      return state
  }
}
